import store from '../../vuex/store';

let XDate = window.Date;
XDate.prototype.Format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};
XDate.prototype.setDateCalu = function (n) {
  var targetday_milliseconds = this.getTime() + n;
  this.setTime(targetday_milliseconds);
  return this;
};

let utils = {
  /**
   *  @description 将对象数组中的key 属性解析为数组
   *  @param list 对象数组
   *  @param key 属性
   *  @returns 返回的属性数组
   */
  formatterDataList(list, key = "id") {
    if (list == null || list.length < 1) return [];
    return list.map(it => {
      return it[key];
    });
  },
  /**
   * //获取对象中的部分字段，返回新的对象
   * @param {*} obj   {a: 1,b: 2, c: 3, d: 4, e: 5}
   * @param {*} arr ['a', 'd', 'e']
   * @returns  {a: 1, d: 4, e: 5}
   */
  pick(obj, arr) {
    return arr.reduce((iter, val) => (val in obj && (iter[val] = obj[val]), iter), {})
  },
  getParam(paramName) {
    let paramValue = "",
      isFound = !1;
    if (location.hash.indexOf("?") > 0 && location.hash.indexOf("=") > 1) {
      var index = location.hash.indexOf("?");
      var arrSource = decodeURIComponent(location.hash)
        .substring(index + 1, location.hash.length)
        .split("&"),
        i = 0;
      while (i < arrSource.length && !isFound)
        arrSource[i].indexOf("=") > 0 &&
          arrSource[i].split("=")[0].toLowerCase() == paramName.toLowerCase() &&
          ((paramValue = arrSource[i].split("=")[1]), (isFound = !0)),
          i++;
    }
    return paramValue == "" && (paramValue = null), paramValue;
  },
  uuNum(len) {
    var text = "";
    var possible = "123456789";
    for (var i = 0; i < len; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
  },
  uniqArry(array) {
    var temp = []; //一个新的临时数组
    for (var i = 0; i < array.length; i++) {
      if (temp.indexOf(array[i]) == -1) {
        temp.push(array[i]);
      }
    }
    return temp;
  },
  dateMonthStartFormat: function () {
    var date = new Date();
    var y = date.getFullYear();
    var M = date.getMonth() + 1;
    var d = date.getDate();
    return y + "-" + (M < 10 ? "0" + M : M) + "-01";
  },
  /**
   * 生成随机字符串
   * @param {*} len 随机字符串的长度
   */
  getRandomCode: function (len = 10) {
    for (var e = "1234567890qwertyuiopasdfghjklzxcvbnm", t = e.length, o = [], i = 0; i < len; i += 1) {
      var n = Math.floor(Math.random() * t);
      o.push(e[n])
    }
    return o.join("")
  },
  /**
   * 生成随机字符串
   * @param {*} e  随机字符串的长度 
   * @param {*} t 取字符串的前多少位(小于等于62)
   */
  uuid: function (e, t) {
    var n, a, o, i;
    if (
      ((n = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".split(
        ""
      )),
        (i = []),
        (a = void 0),
        (t = t || n.length),
        e)
    )
      for (a = 0; a < e;)(i[a] = n[0 | (Math.random() * t)]), a++;
    else
      for (
        o = void 0, i[8] = i[13] = i[18] = i[23] = "", i[14] = "4", a = 0; a < 36;

      )
        i[a] ||
          ((o = 0 | (16 * Math.random())),
            (i[a] = n[19 === a ? (3 & o) | 8 : o])),
          a++;
    return i.join("");
  },
  isContainClassNameByEvent(event, calssName) {
    var event = window.event || arguments.callee.caller.arguments[0];
    let target = event.target || event.srcElement;
    if (target.className != null && target.className.indexOf(calssName) > 0) {
      return true;
    } else {
      return false;
    }
  },
  getFileType(filename) {
    //根据文件名返回对应文件类型
    //let type = isFolder ? 'folder' : 'unknown'
    let index = filename.lastIndexOf(".");
    let extension = filename.substr(index + 1);
    let type = "unknown";
    const typeMap = {
      img: ["gif", "jpg", "jpeg", "png", "bmp", "webp", "ico"],
      video: ["mp4", "m3u8", "rmvb", "avi", "swf", "3gp", "mkv", "flv"],
      audio: ["mp3", "wav", "wma", "ogg", "aac", "flac"],
      doc: ["doc", "txt", "docx", "pages", "epub", "numbers", "keynote"],
      //document: ['doc', 'txt', 'docx', 'pages', 'epub', 'pdf', 'numbers', 'csv', 'xls', 'xlsx', 'keynote', 'ppt', 'pptx']
      ppt: ["ppt", "pptx"],
      xls: ["csv", "xls", "xlsx"],
      pdf: ["pdf"],
      zip: ["rar", "zip", "7z", "jar", "gz"]
    };
    Object.keys(typeMap).forEach(_type => {
      const extensions = typeMap[_type];
      if (extensions.indexOf(extension) > -1) {
        type = _type;
        return type;
      }
    });
    return type;
  },
  isEmptyArry(arr) {
    if (arr == null || arr.length < 1) return true;
    else return false;
  },
  /**
   * @description 判断数组是否存在重复项
   * @param {*} arr  数组
   * @returns true-不存在重复 false-存在重复
   */
  isSetArr(arr) {
    if (new Set(arr).size !== arr.length) {
      return false;
    }
    return true;
  },
  /**
   * @description 找到数组中重复项的第一个
   * @param {*} arr  数组
   * @returns  重复项的下标,-1 不存在重复项
   */
  getReaptIndexArr(arr) {
    for (let [i, v] of arr.entries()) {
      var bool = arr.indexOf(v, i + 1);
      if (bool > -1) {
        return bool;
      }
      return -1;
    }
  },
  /**
   * @description 数组去重
   * @param {*} arr  数组
   * @returns  重复项的下标,-1 不存在重复项
   */
  getDistinctArr(arr) {
    let data = [];
    arr.map((v, i, arr) => {
      let bool = arr.indexOf(v, i + 1);
      if (bool === -1) {
        data.push(v);
      }
    });
    return data;
  }
};
let validateUtil = {
  isEmpty: function (v) {
    if (v == null) {
      return false;
    }
    v = v.replace(/\s+/g, ""); //去除所有空格
    if (v.length == 0) {
      return false;
    }
    return true;
  },

  validateURL: function (e) {
    return /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/.test(
      e
    );
  },
  validateLowerCase: function (e) {
    return /^[a-z]+$/.test(e);
  },
  validateUpperCase: function (e) {
    return /^[A-Z]+$/.test(e);
  },
  validatAlphabets: function (e) {
    return /^[A-Za-z]+$/.test(e);
  },
  isPhoneNum: function (e) {
    return this.isPhone(e) || this.isMobile(e);
  },
  isPhone: function (e) {
    if (null == e || "" == e) return !1;
    return /[0-9]{1}[0-9]{2,3}-[1-9]{1}[0-9]{5,8}/.test(e);
  },
  isMobile: function (e) {
    if (null == e || "" == e) return false;
    return /^1[3456789][0-9]{9}$/.test(e);
  },
  checkName: function (e) {
    return /^[A-Za-z0-9\u4e00-\u9fa5]+$/.test(e);
    // return /^[\u4e00-\u9fa5]+$/.test(e)
  },
  checkEmail: function (e) {
    return /^\w+((-\w+)|(\.\w+))*@\w+(\.\w{2,3}){1,3}$/.test(e);
  },
};
let courseUtil = {
  loginUrl: "../course/",
  openCourse() {
    window.open(this.loginUrl, "_blank");
  },
  openCourseUrl(courseID) {
    window.open("https://www.treetask.cn/#/courseDetail/" + courseID, "_blank");
  },
  openNewCourse() {
    window.open(this.loginUrl + "#/editacticle/new");
  }
};
//格式化
let formatterUtil = {
  seariID: new Date().getTime(), //自增
  plusXing(str, frontLen, endLen) {
    var len = str.length - frontLen - endLen;
    var xing = "";
    for (var i = 0; i < len; i++) {
      xing += "*";
    }
    return (
      str.substring(0, frontLen) + xing + str.substring(str.length - endLen)
    );
  },

  htmlEscape: function (str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\\/g, "\\\\")
      .replace(/\r/g, "\\r")
      .replace(/\n/g, "\\n");
  },
  htmlUnEscape: function (str) {
    str = String(str)
      .replace(/&amp;/g, "&")
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/\\\\/g, "\\")
      .replace(/\\r/g, "\r")
      .replace(/\\n/g, "\n");
    return str;
  },
  formatterList2Str(arr, ckey, split) {
    if (arr != null && arr.length > 0) {
      return arr
        .map(v => {
          return v[ckey];
        })
        .join(split);
    }
    return "";
  },
  //用户管理-用户树
  formatterDeptUserTree(res) {
    var str = "";
    for (let i = 0; i < res.length; i++) {
      let d = res[i];
      str += "[{";
      str += '"id":' + d.deptID + ',"label":"' + d.deptName + '"';
      str = this.formatterDeptUser(str, d);
      str += "}]";
    }
    return str;
  },
  formatterDeptUser(str, obj) {
    let child = obj.deptList;
    if (child != null && child.length > 0) {
      str += ',"childrens":[';
      for (let i = 0; i < child.length; i++) {
        let d = child[i];
        let seariID = this.seariID++;
        str +=
          '{"deptID":' +
          d.deptID +
          ',"label":"' +
          d.deptName +
          '","type":' +
          d.type +
          ',"id":' +
          seariID +
          "";
        if (d.type == 2) {
          str = this.formatterDeptUser(str, d);
        }
        if (i < child.length - 1) str += "},";
        else str += "}";
      }
      str += "]";
    } else {
      let child = obj.userList;
      if (child != null && child.length > 0) {
        str += ',"childrens":[';
        for (let i = 0; i < child.length; i++) {
          let d = child[i];
          let mangerID = d.mangerID;
          if (mangerID == null) {
            mangerID = "";
          }
          str +=
            '{"userID":' +
            d.userID +
            ',"label":"' +
            d.userName +
            '","id":' +
            d.userID +
            ',"userName":"' +
            d.userName +
            '","phone":"' +
            d.phone +
            '","stationName":"' +
            d.stationName +
            '","loginID":"' +
            d.loginID +
            '","stationID":' +
            d.stationID +
            ',"deptID":' +
            d.deptID +
            ',"email":"' +
            d.email +
            '","identityID":"' +
            d.identityID +
            '","district":"' +
            d.district +
            '","remark":"' +
            d.remark +
            '","mangerID":"' +
            mangerID +
            '","mangerName":"' +
            d.mangerName +
            '","accNum":"' +
            d.accNum +
            '","deptName":"' +
            d.deptName +
            '","type":' +
            d.type +
            "";
          if (i < child.length - 1) str += "},";
          else str += "}";
        }
        str += "]";
      }
    }
    return str;
  },
  //treeselect 部门
  formatterTreeDept_Station(res, excludeArr = []) {
    var str = "";
    for (let i = 0; i < res.length; i++) {
      let d = res[i];
      str += "[{";
      str +=
        '"deptID":' +
        d.deptID +
        ',"label":"' +
        d.deptName +
        '","text":"' +
        d.deptName +
        '","type":' +
        d.type +
        ',"id":' +
        d.deptID;
      str = this.getTreeDeptStation_Str(str, res[i], excludeArr);
      str += "}]";
    }
    return str;
  },
  getTreeDeptStation_Str(str, obj, excludeArr = []) {
    let child = obj.deptList;
    if (child != null && child.length > 0) {
      str += ',"children":[';
      for (let i = 0; i < child.length; i++) {
        let d = child[i];
        let seariID = this.seariID++;
        str +=
          '{"deptID":' +
          d.deptID +
          ',"label":"' +
          d.deptName +
          '","text":"' +
          d.deptName +
          '","type":' +
          d.type +
          ',"id":' +
          d.deptID;
        if (excludeArr.includes(d.deptID)) {
          str += `,"isDisabled":true`;
        }
        if (d.type == 2) {
          str = this.getTreeDeptStation_Str(str, d, excludeArr);
        }
        if (i < child.length - 1) str += "},";
        else str += "}";
      }
      str += "]";
    } else {
      let child = obj.stationList;
      if (child != null && child.length > 0) {
        str += ',"children":[';
        for (let i = 0; i < child.length; i++) {
          let d = child[i];
          str +=
            '{"stationID":' +
            d.stationID +
            ',"label":"' +
            d.stationName +
            '","text":"' +
            d.deptName +
            '","type":' +
            d.type +
            ',"id":' +
            this.seariID +
            "";
          if (d.type == 3) {
            str = this.getTreeDeptStation_Str(str, d);
          }
          if (i < child.length - 1) str += "},";
          else str += "}";
        }
        str += "]";
      }
    }
    return str;
  },

  //用户管理:部门树
  formatterDeptTree(res) {
    var str = "";
    for (let i = 0; i < res.length; i++) {
      let d = res[i];
      str += "[{";
      let mangerName = d.mangerName || '';
      let gradeName = d.gradeName || '';
      let deptSeq = d.deptSeq || '';
      let mangerID = d.mangerID || null;
      str += `"pdeptID":"${d.pdeptID}","mangerID":${mangerID},"deptID":${d.deptID},"deptName":"${d.deptName}" ,"label":"${d.deptName}","type":${d.type},"id":${d.deptID},"icon":"iconfont icon-company","mangerName":"${mangerName}","gradeID":${d.gradeID},"gradeName":"${gradeName}","perNum":${d.perNum},"deptSeq":"${deptSeq}","checked":false`;
      str = this.getDeptTreeStr(str, res[i]);
      str += "}]";
    }
    return str;
  },
  getDeptTreeStr(str, obj) {
    let child = obj.deptList;
    if (child != null && child.length > 0) {
      str += ',"children":[';
      for (let i = 0; i < child.length; i++) {
        let d = child[i];
        //gradeID
        let mangerName = d.mangerName || '';
        let gradeName = d.gradeName || '';
        let deptSeq = d.deptSeq || '';
        let mangerID = d.mangerID || null;
        str += `{"pdeptID":"${d.pdeptID}","mangerID":${mangerID},"deptID":${d.deptID},"deptName":"${d.deptName}","label":"${d.deptName}","type":${d.type},"id":${d.deptID},"icon":"fa fa-briefcase","mangerName":"${mangerName}","gradeID":${d.gradeID},"gradeName":"${gradeName}","perNum":${d.perNum},"deptSeq":"${deptSeq}","checked":false`;
        if (d.type == 2) {
          str = this.getDeptTreeStr(str, d);
        }
        if (i < child.length - 1) str += "},";
        else str += "}";
      }
      str += "]";
    }
    return str;
  },




  formatterPositionGroupTree(res) {
    var str = "[";
    for (let i = 0; i < res.length; i++) {
      let d = res[i];
      let seariID = this.seariID++;
      str += `{"id":${seariID},"label":"${d.posGroupName}","posGroupName":"${d.posGroupName}","posGroupID":"${d.posGroupID}"`;
      str = this.getPositionGroupTreeStr(str, d);
      if (utils.isEmptyArry(d.stationList)) {
        str += `,"isDisabled":true`;
      }
      if (i < res.length - 1) str += "},";
      else str += "}";
    }
    str += "]";
    return str;
  },
  getPositionGroupTreeStr(str, obj) {
    let child = obj.stationList;
    if (child != null && child.length > 0) {
      str += `,"children":[`;
      for (let i = 0; i < child.length; i++) {
        let d = child[i];
        let seariID = this.seariID++;
        str += `{"stationID":${d.stationID},"label":"${d.stationName}","id":${d.stationID},"posGroupID":"${d.posGroupID}","posGroupName":"${d.posGroupName}","stationName":"${d.stationName}"`;
        if (i < child.length - 1) str += "},";
        else str += "}";
      }
      str += "]";
    }
    return str;
  },

  formatterDeptUser(res) {
    var str = "";
    for (let i = 0; i < res.length; i++) {
      let d = res[i];
      str += "[{";
      let seariID = this.seariID++;
      str += '"id":' + seariID + ',"label":"' + d.deptName + '"';
      str = this.getDeptUserStr(str, res[i]);
      str += "}]";
    }
    return str;
  },
  getDeptUserStr(str, obj) {
    let dchild = obj.deptList;
    let uchild = obj.userList;
    if (dchild == null || dchild.length < 1) {
      dchild = [];
    }
    if (uchild == null || uchild.length < 1) {
      uchild = [];
    }
    let child = dchild.concat(uchild);
    if (child != null && child.length > 0) {
      str += `,"children":[`;
      for (let i = 0; i < child.length; i++) {
        let d = child[i];
        let seariID = this.seariID++;
        if (d.type == 2)
          str += `{"deptID":${d.deptID},"label":"${d.deptName}","type":${d.type},"id":"${seariID}"`;
        if (d.type == null)
          str += `{"userID":"${d.userID}","label":"${d.userName}","id":"${seariID}"`;
        /*if (d.type == 2) {
          if (utils.isEmptyArry(d.deptList) && utils.isEmptyArry(d.userList)) {
            str += `,"isDisabled":true`;
          }
          str = this.getDeptUserStr(str, d);
        }*/
        if (i < child.length - 1) str += "},";
        else str += "}";
      }
      str += "]";
    } else {
      let child = obj.userList;
      if (child != null && child.length > 0) {
        str += `,"children":[`;
        for (let i = 0; i < child.length; i++) {
          let d = child[i];
          let seariID = this.seariID++;
          if (d.type == null) {
            str = this.getDeptUserStr(str, d);
          }
          if (i < child.length - 1) str += "},";
          else str += "}";
        }
        str += "]";
      }
    }
    return str;
  },

  //用户管理:任务树
  /*部门和人员不在同一层的*/
  formatterDeptUserTask(res) {
    var str = "";
    for (let i = 0; i < res.length; i++) {
      let d = res[i];
      str += "[{";
      let seariID = this.seariID++;
      str += '"id":' + seariID + ',"label":"' + d.deptName + '"';
      str = this.getDeptTaskStr(str, res[i]);
      str += "}]";
    }
    return str;
  },

  getDeptTaskStr(str, obj) {
    let dchild = obj.deptList || [];
    let uchild = obj.userList || [];
    if (dchild != null && dchild.length > 0) {
      str += `,"children":[`;
      for (let i = 0; i < dchild.length; i++) {
        let d = dchild[i];
        let seariID = this.seariID++;
        str += `{"deptID":${d.deptID},"label":"${d.deptName}","type":${d.type},"id":"${seariID}"`;
        if (d.type == 2) {
          if (utils.isEmptyArry(d.deptList) && utils.isEmptyArry(d.userList)) {
            str += `,"isDisabled":true`;
          }
          str = this.getDeptTaskStr(str, d);
        }
        if (i < child.length - 1) str += "},";
        else str += "}";
      }
      str += "]";
    }
    if (uchild != null && uchild.length > 0) {
      str += `,"children":[`;
      for (let i = 0; i < uchild.length; i++) {
        let d = uchild[i];
        let seariID = this.seariID++;
        str += `{"userID":"${d.userID}","label":"${d.userName}","id":"${seariID}"`;
        if (d.type == null) {
          str = this.getDeptTaskStr(str, d);
        }
        if (i < child.length - 1) str += "},";
        else str += "}";
      }
      str += "]";
    }
    /*else {
      let child = obj.userList;
      if (child != null && child.length > 0) {
        str += `,"children":[`;
        for (let i = 0; i < child.length; i++) {
          let d = child[i];
          let seariID = this.seariID++;
          str += `{"userID":"${d.userID}","label":"${d.userName}","id":"${seariID}"`;
          if (d.type == null) {
            str = this.getDeptTaskStr(str, d);
          }
          if (i < child.length - 1) str += "},";
          else str += "}";
        }
        str += "]";
      }
    }*/
    return str;
  },
  //菜单-功能点
  formatterMenuPermission(res) {
    var str = "[";
    for (let i = 0; i < res.length; i++) {
      let d = res[i];
      str += "{";
      let check = (d.check || 0) == 1 ? true : false;
      let serviceStopTimeStr = d.menuCompany ? d.menuCompany.serviceStopTimeStr : ''
      str += `"menuName":"${d.menuName}","goodsCode":"${d.goodsCode}","serviceStopTimeStr":"${serviceStopTimeStr}","label":"${d.menuName}","id":${d.menuID},"check":${check},"icon":"el-icon-folder-opened","menuType":${d.menuType},"parentMenuID":${d.parentMenuID},"type":${d.type}`;
      str = this.getMenuStr(str, res[i]);
      if (i < res.length - 1) str += "},";
      else str += "}";
    }
    str += "]";
    return str;
  },
  getUserName(userID) {
    if (userID == '' || userID == null) return ''
    let list = store.state.allUserUnip
    let temp1 = list.find(it => it["userID"] == userID);
    return temp1 ? temp1.userName || temp1.label : '';
  },
  formatterUsserOver(arr, num = 4) {
    if (arr == null || arr.length < 1) return ''
    if (arr.length < num) return this.formatterTargetUser(arr)
    else {
      let numArr = arr.slice(0, num);
      let str = this.formatterTargetUser(numArr) + ` 等${arr.length}人`;
      return str;
    }
  },
  formatterTargetUser(ids = [], id = null, split = ',') {
    let namestr = "";
    let list = store.state.allUserUnip
    if (list && list.length > 0) {
      if (ids && ids.length > 0) {
        namestr = ids.map(v => this.getUserName(v)).join(split);
      } else {
        namestr = this.getUserName(id);
      }
    }
    return namestr;
  },
  getMenuStr(str, obj, ckey = 'children') {
    let child = obj.menuList;
    if (child != null && child.length > 0) {
      str += `,"${ckey}":[`;
      for (let i = 0; i < child.length; i++) {
        let d = child[i];
        let check = (d.check || 0) == 1 ? true : false;
        let parentMenuID = d.parentMenuID || 0;
        let serviceStopTimeStr = d.menuCompany ? d.menuCompany.serviceStopTimeStr : ''
        str += `{"menuName":"${d.menuName}","goodsCode":"${d.goodsCode}","serviceStopTimeStr":"${serviceStopTimeStr}","label":"${d.menuName}","id":${d.menuID},"check":${check},"parentMenuID":${parentMenuID},"menuType":${d.menuType},"type":${d.type}`;

        if (utils.isEmptyArry(d.menuList)) {
          str = this.getMenuStr(str, d);
          str += `,"icon":"el-icon-tickets"`;
        } else {
          // menuType 0 菜单 1功能点
          // type  //级别类型,0-保留，1-基础 2-普通，10-vip

          if (d.menuList[0].menuType == 1) { //
            str = this.getMenuStr(str, d, 'clist');
            str += `,"icon":"el-icon-tickets"`;
          } else {
            str = this.getMenuStr(str, d);
            str += `,"icon":"el-icon-folder-opened"`;
          }
        }
        if (i < child.length - 1) str += "},";
        else str += "}";
      }
      str += "]";
    }
    return str;
  },

  //执行人 负责人 选择
  formatterDeptStation(res, isUnID = false) {
    var str = "";
    res.map(d => {
      let uniID = isUnID ? `d_${d.deptID}` : `${d.deptID}`;
      str += `[{"id":"${uniID}","label":"${d.deptName}","type":${d.type}`;
      str = this.getDepeTreeStr(str, d, isUnID);
      str += "}]";
    })
    return JSON.parse(str);
  },
  //人员和部门并列
  getDepeTreeStr(str, obj, isUnID = false) {
    let dchild = obj.deptList || [];
    let uchild = obj.userList || [];
    let child = dchild.concat(uchild);
    if (child.length > 0) {
      str += ',"children":[';
      for (let i = 0; i < child.length; i++) {
        let d = child[i];
        let uniID = isUnID ? `d_${d.deptID}` : `${d.deptID}`;
        if (d.type == 2) {
          str += `{"deptID":${d.deptID},"label":"${d.deptName}","type":${d.type},"id":"${uniID}"`;
          if (
            utils.isEmptyArry(d.deptList) &&
            utils.isEmptyArry(d.userList)
          ) {
            str += `,"isDisabled":true`;
          } else {
            str = this.getDepeTreeStr(str, d, isUnID = false);
          }
          str += "}";
        }
        if (d.type == null) {
          let uniID = isUnID ? `u_${d.userID}_${obj.deptID}` : `${d.userID}`;
          str += `{"userID":"${d.userID}","label":"${d.userName}","id":"${uniID}"}`;
          // if (i < child.length - 1) str += "},";  else str += "}";
        }
        if (i < child.length - 1) str += ",";
      }
      str += "]";
    }
    return str;
  },
  getNodeArr(data, arr, types = [undefined]) {
    if (types == null) {
      !arr.includes(data) && arr.push(data);
    } else {
      if (types.includes(data.type)) {
        !arr.includes(data) && arr.push(data);
      }
    }
    data.children &&
      data.children.map((item) => {
        this.getNodeArr(item, arr, types);
      });
    return arr;
  },
  uniqObjArry(array, ckey) {
    let newarr = array.filter(function (cur, index, arr) {
      return arr.findIndex(v => v[ckey] == cur[ckey]) === index
    });
    return newarr
  },

  formatterUserAvatar(userName) {
    if (!validateUtil.isEmpty(userName)) {
      return "";
    }
    if (userName.length > 2) {
      return userName.substring(userName.length - 2, userName.length);
    } else {
      return userName;
    }
  },
  formatterTaskDate(str) {
    if (str == null || str.length == 0) return "";
    var date = new Date(str);
    var date1 = new Date();
    var y = date.getFullYear();
    var y1 = date1.getFullYear();
    var M = date.getMonth() + 1;
    var d = date.getDate();
    var h = date.getHours();
    var m = date.getMinutes();
    var s = date.getSeconds();
    if (y == y1)
      return (
        (M < 10 ? "0" + M : M) +
        "月" +
        (d < 10 ? "0" + d : d) +
        "日" +
        " " +
        (h < 10 ? "0" + h : h) +
        ":" +
        (m < 10 ? "0" + m : m)
      );
    else
      return (
        y +
        "年" +
        (M < 10 ? "0" + M : M) +
        "." +
        (d < 10 ? "0" + d : d) +
        " " +
        (h < 10 ? "0" + h : h) +
        ":" +
        (m < 10 ? "0" + m : m)
      );
  },
  splitOption(str) {
    return str.split(/[(\r\n)\r\n]+/); //空格和换行\s\n
  }
};

let localStore = {
  setItem: (key, val) => {
    localStorage.setItem(key, val);
  },
  getItem: (key, defVal) => {
    let val = localStorage.getItem(key);
    if (val === "NaN" || val === "undefined") {
      return defVal == null ? "" : defVal;
    }
    return val;
  },
  removeItem: key => {
    localStorage.removeItem(key);
  }
};
let cookie = {
  //expire day
  setCookie(c_name, value, expire) {
    var date = new Date();
    date.setTime(date.getTime() + expire * 24 * 60 * 60 * 1000);
    document.cookie =
      c_name + "=" + escape(value) + "; expires=" + date.toGMTString();
  },
  getCookie: function (c_name) {
    if (document.cookie.length > 0) {
      let c_start = document.cookie.indexOf(c_name + "=");
      if (c_start != -1) {
        c_start = c_start + c_name.length + 1;
        let c_end = document.cookie.indexOf(";", c_start);
        if (c_end == -1) c_end = document.cookie.length;
        return unescape(document.cookie.substring(c_start, c_end));
      }
    }
    return "";
  }
};
let attachConfig = {
  source: {
    type0: 0,
    type1: 1,
    type2: 2,
    type3: 3,
    type4: 4,
    type5: 5,
    type6: 6,
    type7: 7,
    type8: 8,
    type9: 9 //0任务说明、1执行人反馈、2负责人反馈、3工作说明,4教程，5，规章 6 手册,7项目 8报告 9其他
  },
  downloadFile: function (file) {
    //附件下载
    window.location.href = "/enclosure/download?filePath=" + file.url;
  }
};
let taskConfig = {
  seariID: new Date().getTime(), //自增
  taskCycleOptions: [{
    value: "1",
    label: "每日"
  },
  {
    value: "2",
    label: "每周"
  },
  {
    value: "3",
    label: "每月"
  }
  ],
  weekOptions: [{
    value: "Mon",
    label: "周一"
  },
  {
    value: "Tues",
    label: "周二"
  },
  {
    value: "Wed",
    label: "周三"
  },
  {
    value: "Thur",
    label: "周四"
  },
  {
    value: "Fri",
    label: "周五"
  },
  {
    value: "Sat",
    label: "周六"
  },
  {
    value: "Sun",
    label: "周日"
  }
  ],
  dayOfWeekReplace: function (str) {
    switch (str) {
      case "Mon":
        return "周一";
      case "Tues":
        return "周二";
      case "Wed":
        return "周三";
      case "Thur":
        return "周四";
      case "Fri":
        return "周五";
      case "Sat":
        return "周六";
      case "Sun":
        return "周日";
    }
  },

  auditeResultOptions: [{
    value: "",
    label: "全部"
  },
  {
    value: "Y",
    label: "已通过"
  },
  {
    value: "N",
    label: "未通过"
  }
  ],
  isExpireOptions: [{
    value: "1",
    label: "是"
  },
  {
    value: "0",
    label: "否"
  }
  ],
  isFinishOptions: [{
    value: "0",
    label: "未完成"
  },
  {
    value: "1",
    label: "已完成"
  },
  {
    value: "",
    label: "全部"
  }
  ],
  MangerIsScoreOptions: [{
    value: "0",
    label: "未评分"
  },
  {
    value: "1",
    label: "已评分"
  },
  {
    value: "",
    label: "全部"
  }
  ],
  isDelayOptions: [{
    value: "1",
    label: "是"
  },
  {
    value: "0",
    label: "否"
  }
  ],

  queryTaskDateOptions: [{
    value: "0",
    label: "预计完成时间"
  },
  {
    value: "1",
    label: "创建时间"
  }
  ],
  taskArr: ["日", "周", "月", "临时", "互动"], //1,2,3,4
  taskArrTx: ["日", "周", "月", "临", "互"],
  taskArrText: ["日任务", "周任务", "月任务", "临时任务", "互动任务"], //1,2,3,4，5
  levelText: ["紧急", "重要", "普通", "选做"],
  levelTx: ["急", "重", "普", "选"],
  taskScoreOptions: [{
    id: "",
    label: "全部"
  },
  {
    id: "1",
    label: "满绩效点"
  },
  {
    id: "0",
    label: "非满绩效点"
  },
  {
    id: "3",
    label: "扣分"
  },
  {
    id: "2",
    label: "加分"
  }
  ],
  levelColor: ["#e62412", "#fa8c15", "#c1c1c1", "#d9d9d9"],
  tagTypes: ["danger", "warning", "info", "success"],
  level: [{
    id: 0,
    label: "紧急",
    type: "danger",
    checked: false
  },
  {
    id: 1,
    label: "重要",
    type: "warning",
    checked: false
  },
  {
    id: 2,
    label: "普通",
    type: "info",
    checked: false
  },
  {
    id: 3,
    label: "选做",
    type: "success",
    checked: false
  }
  ], // 紧急程度
  levelColor: ["#e62412", "#fa8c15", "#c1c1c1", "#d9d9d9"], //8c8c8c ff5722 #e3e3e3
  taskViewOptions: [{
    id: "0",
    text: "类别视图",
    checked: true
  },
  {
    id: "1",
    text: "列表视图",
    checked: false
  },
  {
    id: "2",
    text: "日程视图",
    checked: false
  },
  {
    id: "3",
    text: "甘特图",
    checked: false
  }
    //6 待领取
  ],
  assessViewOptions: [{
    id: "0",
    text: "卡片视图",
    checked: true
  },
  {
    id: "1",
    text: "列表视图",
    checked: false
  },
  {
    id: "2",
    text: "任务视图",
    checked: false
  }
  ],
  assessViewText: ["卡片视图", "列表视图", "任务视图"],
  taskViewText: ["类别视图", "列表视图", "日程视图", "甘特图"],

  taskTypeOptions: [{
    id: "1",
    text: "未完成",
    prop: "isFinish",
    val: "0",
    checked: true
  },
  {
    id: "6",
    text: "未读任务",
    prop: "executerSee",
    val: "0",
    checked: false
  },
  {
    id: "3",
    text: "已超期",
    prop: "isExpire",
    val: "1",
    checked: false
  },
  {
    id: "4",
    text: "超期未完成",
    prop: "exeIsHide",
    val: "1",
    checked: false
  },
  {
    id: "2",
    text: "已完成",
    prop: "isFinish",
    val: "1",
    checked: false
  },
  {
    id: "5",
    text: "已关闭",
    prop: "isLock",
    val: "0",
    checked: false
  },
  {
    id: "",
    text: "全部",
    checked: false
  }
  ],
  assesseOptions: [{
    id: "1",
    text: "已考核",
    prop: "mangerIsScore",
    val: "1",
    checked: false
  },
  {
    id: "2",
    text: "未考核",
    prop: "mangerIsScore",
    val: "0",
    checked: false
  },
  {
    id: "3",
    text: "未完成",
    prop: "isFinish",
    val: "0",
    checked: true
  },
  {
    id: "4",
    text: "已完成",
    prop: "isFinish",
    val: "1",
    checked: false
  },
  {
    id: "",
    text: "全部",
    checked: false
  }
  ],

  taskSortOptions: [{
    id: "0",
    text: "综合排序",
    checked: true
  },
  {
    id: "1",
    text: "紧急程度",
    checked: false
  },
  {
    id: "2",
    text: "开始时间(最早)",
    checked: false
  },
  {
    id: "3",
    text: "开始时间(最晚)",
    checked: false
  },
  {
    id: "4",
    text: "截止时间(最早)",
    checked: false
  },
  {
    id: "5",
    text: "截止时间(最晚)",
    checked: false
  },
  {
    id: "6",
    text: "按绩效点(最多)",
    checked: false
  },
  {
    id: "7",
    text: "按扣分(最多)",
    checked: false
  },
  {
    id: "8",
    text: "按加分(最多)",
    checked: false
  }
  ],
  queryTaskTypeOptions: [{
    value: "1",
    label: "日任务"
  },
  {
    value: "2",
    label: "周任务"
  },
  {
    value: "3",
    label: "月任务"
  },
  {
    value: "4",
    label: "临时任务"
  },
  {
    value: "",
    label: "全部"
  }
  ],
  queryAllTaskTypeOptions: [{
    value: "1",
    label: "日任务"
  },
  {
    value: "2",
    label: "周任务"
  },
  {
    value: "3",
    label: "月任务"
  },
  {
    value: "4",
    label: "临时任务"
  },
  {
    value: "5",
    label: "互动任务"
  },
  {
    value: "",
    label: "全部"
  }
  ],
  queryTaskTypeOptions2: [{
    value: "1",
    label: "日任务"
  },
  {
    value: "2",
    label: "周任务"
  },
  {
    value: "3",
    label: "月任务"
  }
  ]
};

let taskFormatter = {
  /**
   * @description 判断任务是否即将超期
   * @param {*} item  mission
   */
  isTaskTimeOut(item) {
    if (
      item.isExpire == "0" &&
      item.isFinish == "0" &&
      item.appClose == 0 &&
      item.appDelay == 0 &&
      item.appEdit == 0
    ) {
      let etc = item.etc;
      if (etc == "" || etc == null) return false;
      var date = new Date(etc);
      var date1 = new Date();
      var y = date.getFullYear();
      var M = date.getMonth() + 1;
      var d = date.getDate() + 1;
      var y1 = date1.getFullYear();
      var M1 = date1.getMonth() + 1;
      var d1 = date1.getDate();
      if (y == y1 && M == M1 && d == d1) return true;
      else return false;
    } else {
      return false;
    }
  },
  seariID: new Date().getTime(),
  //任务设置  类别树形结构
  formatterDept_Station(res) {
    var str = "";
    for (let i = 0; i < res.length; i++) {
      let d = res[i];
      str += "[{";
      str +=
        '"kindID":' +
        d.kindID +
        ',"label":"' +
        d.kindName +
        '","type":' +
        d.type +
        ',"id":"' +
        d.kindID +
        '","icon":"tree-icon-company iconfont icon-company","parentKindID":' +
        d.parentKindID +
        ',"level":"' +
        d.level +
        '"';
      str = this.getDeptStation_Str(str, res[i]);
      str += "}]";
    }
    return str;
  },
  getDeptStation_Str(str, obj) {
    let child = obj.kindList;
    if (child != null && child.length > 0) {
      str += ',"children":[';
      for (let i = 0; i < child.length; i++) {
        let d = child[i];
        let seariID = this.seariID++;
        str +=
          '{"id":"' +
          d.kindID +
          '","kindID":' +
          d.kindID +
          ',"label":"' +
          d.kindName +
          '","type":' +
          d.type +
          ',"icon":"tree-icon-dept fa fa-briefcase","parentKindID":' +
          d.parentKindID +
          ',"level":"' +
          d.level +
          '"';
        if (d.type == 2) {
          str = this.getDeptStation_Str(str, d);
        }
        if (i < child.length - 1) str += "},";
        else str += "}";
      }
      str += "]";
    }
    return str;
  },
  rangeData: {
    checked: [],
    data: ''
  },
  //范围权限
  formatterRange(res) {
    this.rangeData = {
      checked: [],
      data: ''
    };
    var str = "";
    for (let i = 0; i < res.length; i++) {
      let d = res[i];
      if (d.check == 1 || d.check == 2) {
        this.rangeData.checked.push(d.kindID)
      }
      str += "[{";
      str += `"id":"${d.kindID}","kindID":${d.kindID},"label":"${d.kindName}","type":${d.type},"icon":"tree-icon-company fa fa-company","parentKindID":${d.parentKindID},"level":"${d.level}","check":${d.check}`;
      if (d.check == 2) {
        str += `,"disabled":true`;
      }
      str = this.getRange_Str(str, res[i]);
      str += "}]";
    }
    this.rangeData.data = str;
    return this.rangeData;
  },
  getRange_Str(str, obj) {
    let child = obj.kindList;
    if (child != null && child.length > 0) {
      str += ',"children":[';
      for (let i = 0; i < child.length; i++) {
        let d = child[i];
        if (d.check == 1 || d.check == 2) {
          this.rangeData.checked.push(d.kindID)
        }
        str += `{"id":"${d.kindID}","kindID":${d.kindID},"label":"${d.kindName}","type":${d.type},"icon":"tree-icon-dept fa fa-briefcase","parentKindID":${d.parentKindID},"level":"${d.level}","check":${d.check}`;
        if (d.check == 2) {
          str += `,"disabled":true`;
        }
        if (d.type == 2) {
          str = this.getRange_Str(str, d);
        }
        if (i < child.length - 1) str += "},";
        else str += "}";
      }
      str += "]";
    }
    return str;
  },
  //范围权限：部门
  formatterRangeDept(res) {
    var str = "";
    this.rangeData = {
      checked: [],
      data: ''
    };
    for (let i = 0; i < res.length; i++) {
      let d = res[i];
      if (d.check == 1 || d.check == 2) {
        this.rangeData.checked.push(d.deptID)
      }
      str += "[{";
      str += `"deptID":${d.deptID},"deptName":"${d.deptName}" ,"label":"${d.deptName}","type":${d.type},"id":${d.deptID},"icon":"iconfont icon-company","check":${d.check}`;
      if (d.check == 2) {
        str += `,"disabled":true`;
      }
      str = this.getRangeDeptStr(str, res[i]);
      str += "}]";
    }
    this.rangeData.data = str;
    return this.rangeData;
  },
  getRangeDeptStr(str, obj) {
    let child = obj.deptList;
    if (child != null && child.length > 0) {
      str += ',"children":[';
      for (let i = 0; i < child.length; i++) {
        let d = child[i];
        if (d.check == 1 || d.check == 2) {
          this.rangeData.checked.push(d.deptID)
        }
        str += `{"deptID":${d.deptID},"deptName":"${d.deptName}","label":"${d.deptName}","type":${d.type},"id":${d.deptID},"icon":"fa fa-briefcase","check":${d.check}`;
        if (d.check == 2) {
          str += `,"disabled":true`;
        }
        if (d.type == 2) {
          str = this.getRangeDeptStr(str, d);
        }
        if (i < child.length - 1) str += "},";
        else str += "}";
      }
      str += "]";
    }
    return str;
  },
};

let canvasUtil = {
  htmlToCanvas: function (dom) {
    let img = null;
    html2canvas(dom).then(function () {
      // canvas宽度
      var canvasWidth = canvas.width;
      // canvas高度
      var canvasHeight = canvas.height;
      //let canvasWidth=100;
      //let canvasHeight=100;
      img = Canvas2Image.convertToImage(canvas, canvasWidth, canvasHeight);
    });
    return img;
  }
};


export {
  utils,
  validateUtil,
  courseUtil,
  formatterUtil,
  taskConfig,
  attachConfig,
  cookie,
  localStore,
  XDate,
  taskFormatter,
  canvasUtil,
};



// WEBPACK FOOTER //
// ./src/components/utils/utils.js